import { fromPairs } from 'lodash'

export function formatDate (datestring: string, locale: Intl.LocalesArgument = 'en', options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }) {
  if (!datestring) return
  const date = new Date(datestring)
  return date.toLocaleDateString(locale, options)
}

export function getAssetURL (filepath: string): string {
  return new URL(`../assets/${filepath}`, import.meta.url).href
}

export function groupBy (data: Array<object>, key: string, options?: { fallbackGroup?: string | false, transformer?: (value: object) => unknown }) {
  const {
    fallbackGroup = 'default',
    transformer = (value: object) => value
  } = options || {}

  return data.reduce((acc, item) => {
    const group = typeof item[key] === 'string' ? item[key] : fallbackGroup
    if (group) {
      if (!acc[group]) acc[group] = []
      acc[group].push(transformer(item))
    }
    return acc
  }, {})
}

export function sleep (time: number) {
  return new Promise(resolve => setTimeout(resolve, time))
}

export async function processPromises<T = unknown> (promises: Promise<T>[]): Promise<{ fulfilled: T[], rejected: Error[] }> {
  const results = await Promise.allSettled(promises)
  return results.reduce((acc, res) => {
    if ('reason' in res) {
      acc.rejected.push(res.reason)
    } else {
      acc.fulfilled.push(res.value)
    }
    return acc
  }, { fulfilled: [] as T[], rejected: [] as Error[] })
}

export function memoize (fn) {
  if (typeof fn !== 'function') {
    throw new Error('Memoization not allowed: the argument must be a function')
  }

  const cache = {}

  return function (...args) {
    const key = JSON.stringify(args)

    if (!cache.hasOwnProperty(key)) { // eslint-disable-line
      cache[key] = fn.apply(this, args)
    }

    return cache[key]
  }
}

export const parseUrlQuery = (
  url = window.location.search
): Record<string, string> =>
  fromPairs(
    url
      .replace('?', '')
      .split('&')
      .filter(Boolean)
      .map((parameter) => parameter.split('='))
  )

export const delay = (sec: number) => {
  try {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(true)
      }, sec * 1000)
    )
  } catch (error) {
    console.error(error)
  }
}
